import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/** Ligado pelo AppComponent no início de cada navegação. */
export const clienteVoltarNavegacao = {
  indoParaClienteEditar: false,
};

/**
 * Guarda a tela deixada ao abrir cliente/editar e devolve a mesma instância
 * na volta: aba, filtro, busca, rolagem e seleção.
 */
export class ClienteVoltarReuseStrategy implements RouteReuseStrategy {
  private readonly handlers = new Map<string, DetachedRouteHandle>();
  private readonly scrolls = new Map<string, number>();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    if (!clienteVoltarNavegacao.indoParaClienteEditar || !this.temComponente(route)) {
      return false;
    }

    const chave = this.chave(route);
    return chave.length > 0 && !this.ehTelaCliente(chave);
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    const chave = this.chave(route);
    if (!handle) {
      this.handlers.delete(chave);
      const scroll = this.scrolls.get(chave);
      if (scroll != null) {
        this.scrolls.delete(chave);
        setTimeout(() => window.scrollTo(0, scroll));
      }
      return;
    }

    this.scrolls.set(chave, window.scrollY);
    this.handlers.set(chave, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const chave = this.chave(route);
    return chave.length > 0 && this.handlers.has(chave);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return this.handlers.get(this.chave(route)) ?? null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  private temComponente(route: ActivatedRouteSnapshot): boolean {
    return !!(route.component || route.routeConfig?.component);
  }

  private ehTelaCliente(chave: string): boolean {
    return chave.includes('cliente/');
  }

  private chave(route: ActivatedRouteSnapshot): string {
    const partes: string[] = [];
    let atual: ActivatedRouteSnapshot | null = route;
    while (atual) {
      partes.unshift(atual.routeConfig?.path ?? '');
      atual = atual.parent;
    }
    return partes.join('/');
  }
}
